// extracted by mini-css-extract-plugin
export default {"containerGif":"Gif_containerGif__bTu4v","title":"Gif_title__61GJe","isLoading":"Gif_isLoading__SvyUw","loadingImg":"Gif_loadingImg__JwhFl","girar":"Gif_girar__HCPlm"};